module.exports = __webpack_public_path__ + "media/images/icons/outlined/notification-eee7b7dd6a77abe8db872185b5abf7c2.svg";